<grid-filter-popup [isFilterActive]="isFilterActive" [width]="750" (onClose)="onPopupClose()"
    (onResetClick)="onResetClick()" (onFilterClick)="onFilterClick()">
    <div class="scrollable filter-body">
        @for (vaccineType of vaccineTypes$ | async; track vaccineType) {
<div class="type-section">
            <label class="filter-title">{{vaccineType.description}}</label>
            <grid-option-list-filter [field]="getFieldName(vaccineType)" optionFieldName="description" [options]="vaccineStatuses$ | async" [filter]="filter"
                [filterService]="filterService" (filterValueChanged)="filterValueChanged()" [submitOnChange]="false">
            </grid-option-list-filter>
        </div>
}
    </div>
</grid-filter-popup>
